/**
 * TrustStrip — iter87.199.75
 *
 * Below-the-fold reassurance rail. Three columns of "we've thought
 * about the awkward stuff" copy so a prospective Pro+ buyer doesn't
 * bounce on trust anxieties.
 */
import React from "react";
import { RotateCcw, Mail, Lock } from "lucide-react";

const CARDS = [
    {
        slug: "cancel",
        Icon: RotateCcw,
        title: "Cancel anytime",
        body: "One tap in the hub. Your rivalries + trophies stay yours forever — you just lose new-rivalry creation until you resubscribe.",
    },
    {
        slug: "recovery",
        Icon: Mail,
        title: "Magic-link recovery",
        body: "Every Rivalry you create emails you a personal recovery link the moment it goes live. Lost access? Type the code. You're in.",
    },
    {
        slug: "privacy",
        Icon: Lock,
        title: "Your crew is your business",
        body: "No public leaderboards. No open-web ranking. Only the crewmates you invite ever see your rivalry.",
    },
];

export default function TrustStrip() {
    return (
        <section
            className="max-w-6xl mx-auto px-4 py-12"
            aria-label="Trust & recovery"
            data-testid="pro-plus-trust-strip"
        >
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                {CARDS.map(({ slug, Icon, title, body }) => (
                    <div
                        key={slug}
                        data-testid={`pro-plus-trust-${slug}`}
                        className="p-5 rounded-lg border border-zinc-800 bg-zinc-900/40"
                    >
                        <Icon className="w-4 h-4 text-cyber mb-3" />
                        <p className="text-sm font-bold text-white mb-1.5">{title}</p>
                        <p className="text-xs text-zinc-400 leading-relaxed">{body}</p>
                    </div>
                ))}
            </div>
        </section>
    );
}
